import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import List from '../components/Board/List';

const makeMapStateToProps = () => {
  const selectListById = selectors.makeSelectListById();
  const selectCardNamesByIds = selectors.makeSelectCardNamesByIds();

  return (state, { id }) => {
    const { name, color, isPersisted } = selectListById(state, id);

    const isCurrentUserEditor = selectors.selectCanEditBoard(state);

    // ─── C2 : données du NIVEAU 0 (feuilles) pour cette liste ───
    const layout = selectors.selectHierarchyLayoutForCurrentBoard(state);

    // cardIds feuilles dans l'ordre (depuis lanes[0][id])
    const cardIds = (layout && layout.lanes && layout.lanes[0] && layout.lanes[0][id]) || [];

    // groupes feuilles (depuis groupsByLevel[0][id])
    const listGroups = (layout &&
      layout.groupsByLevel &&
      layout.groupsByLevel[0] &&
      layout.groupsByLevel[0][id]) || {
      parentGroups: {},
      orphanCardIds: cardIds,
    };

    const parentIds = Object.keys(listGroups.parentGroups);
    const parentNames = selectCardNamesByIds(state, parentIds);

    return {
      name,
      color,
      isPersisted,
      cardIds,
      canEdit: isCurrentUserEditor,
      listGroups,
      parentNames,
      hideHeader: true, // ─── C2 : header géré en haut de HierarchyView ───
    };
  };
};

const mapDispatchToProps = (dispatch, { id }) =>
  bindActionCreators(
    {
      onUpdate: (data) => entryActions.updateList(id, data),
      onSort: (data) => entryActions.sortList(id, data),
      onDelete: () => entryActions.deleteList(id),
    },
    dispatch,
  );

export default connect(makeMapStateToProps, mapDispatchToProps)(List);
